import Field from "components/shared/field";
import Select from "components/shared/select";
import React, { Fragment } from "react";
import { list } from "sources/books/organizationDocuments";

const CargoOwnerDocsForm = (props) => {
    const { documents } = props;
    const renderOrgDocument = (doc) => {
        const fieldProps = {
            label: doc.name,
            value: doc.count,
            disabled: props.disabled,
            inputProps: {
                name: "documents",
                type: "number",
                step: "1",
                className: "field-wrap__input field-wrap__input--small",
            },
            onChange: ({ value }) => {
                const newValue = value ? parseInt(value) : "";
                const newDocs = documents.map((item) => (item.id === doc.id ? { ...item, count: newValue } : item));
                props.setValue({ name: "documents", value: newDocs });
            },
        };
        const removeDoc = () => {
            const newDocs = documents.filter((item) => item.id !== doc.id);
            props.setValue({ name: "documents", value: newDocs });
        };
        return (
            <tr key={doc.id}>
                <td>{doc.name}</td>
                <td>
                    <Field {...fieldProps} />
                </td>
                {!props.disabled && (
                    <td>
                        <div className="inline-btn inline-btn--without-icon" onClick={removeDoc}>
                            Удалить
                        </div>
                    </td>
                )}
            </tr>
        );
    };

    const selectProps = {
        inputProps: {
            name: "document",
        },
        propName: "name",
        value: null,
        url: list,
        onChange: ({ option }) => {
            const newDocs = [...documents, { id: option.id, name: option.name, count: 1 }];
            props.setValue({ name: "documents", value: newDocs });
        },
        excludeItems: documents.map((item) => item.id),
        placeholder: <small>Добавить документ</small>,
        menuPortalTarget: document.body,
    };

    return (
        <Fragment>
            <table className="table table-sm table--vertical-centered">
                <thead>
                    <tr>
                        <th>Название</th>
                        <th>Кол-во документов</th>
                        {!props.disabled && <th />}
                    </tr>
                </thead>
                <tbody>{documents.map(renderOrgDocument)}</tbody>
            </table>
            {!props.disabled && (
                <div className="row">
                    <div className="col-md-6 col-sm-12">
                        <Select {...selectProps} />
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default CargoOwnerDocsForm;
